module.exports = __webpack_public_path__ + "static/media/next-steps-3.11093a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/next-steps-3.png
// module id = 2635
// module chunks = 0